/**
 * Registra o SW apenas em produção (evita cache estranho no `npm start`).
 * Necessário para o prompt "Instalar app" no Android/Chrome cumprir os requisitos de PWA.
 */
export function registerPwaServiceWorker() {
  if (process.env.NODE_ENV !== 'production' || typeof window === 'undefined' || !('serviceWorker' in navigator)) {
    return;
  }
  window.addEventListener('load', () => {
    const url = `${process.env.PUBLIC_URL || ''}/sw.js`;
    navigator.serviceWorker
      .register(url)
      .then((reg) => reg.update())
      .catch(() => {});
  });
}
